export enum EventState {
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  RESCHEDULED = 'RESCHEDULED',
  UPCOMING = 'UPCOMING',
}
